export function renderPropertyHtml({ property }) {
  const iconMarkup = svgFor(
    property.typeString,
    property.isShortlisted,
    property.advertType
  );
  let iconColor = property.featured ? '#F48831' : '#0082B8';

  if (property.isShortlisted) {
    if (property.isSelected) {
      iconColor = 'white';
    } else {
      iconColor = '#E02424';
    }
  }

  let backgroundStyle =
    property.featured && property.isSelected
      ? 'linear-gradient(266deg, #F48831 14.01%, #FFA20C 33.86%, #F48831 89.15%)'
      : 'white';

  return `
    <div class="marker-content" data-testid="property-marker-content" style="
      background: ${backgroundStyle};
      border-radius: 35px;
      border: 1px solid #D1D5DB;
      padding: 8px 16px;
      display: flex;
      align-items: center;
      gap: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 14px;
      font-weight: 600;
      color: white;
      white-space: nowrap;
      transition: transform 0.2s ease, box-shadow 0.2s ease;
    ">
      <div class="heart-icon" style="
        color: ${iconColor};
        display: flex;
        align-items: center;
        justify-content: center;
      ">
        ${iconMarkup}
      </div>
      <div class="price" style="
        color: #3B4143;
        font-weight: 600;
        font-size: 14px;
      ">£${Math.floor(property.price)}</div>
    </div>
  `;
}

function svgFor(iconType, isShortlisted, advertType) {
  if (isShortlisted) {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 256 256">
        <rect width="256" height="256" fill="none"/>
        <path fill="currentColor" d="M240,94c0,70-103.79,126.66-108.21,129a8,8,0,0,1-7.58,0C119.79,220.66,16,164,16,94A62.07,62.07,0,0,1,78,32c20.65,0,38.73,8.88,50,23.89C139.27,40.88,157.35,32,178,32A62.07,62.07,0,0,1,240,94Z"/>
      </svg>`;
  }

  if (iconType === 'Apartment' && advertType === 'btr') {
    iconType = 'halls';
  }

  if (advertType === 'spare_room') {
    iconType = 'spare_room';
  }

  switch (iconType) {
    case 'Apartment':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 256 256">
          <rect width="256" height="256" fill="none"/>
          <path fill="currentColor" d="M232,224H208V32h8a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16h8V224H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM88,56h24a8,8,0,0,1,0,16H88a8,8,0,0,1,0-16Zm0,40h24a8,8,0,0,1,0,16H88a8,8,0,0,1,0-16Zm-8,48a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16H88A8,8,0,0,1,80,144Zm72,80H104V184h48Zm16-72H144a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16Zm0-40H144a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16Zm0-40H144a8,8,0,0,1,0-16h24a8,8,0,0,1,0,16Z"/>
        </svg>`;
    case 'halls':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 256 256">
          <rect width="256" height="256" fill="none"/>
          <path fill="currentColor" d="M240,208h-8V88a8,8,0,0,0-8-8H160a8,8,0,0,0-8,8v40H104V40a8,8,0,0,0-8-8H32a8,8,0,0,0-8,8V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM72,184a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm0-48a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm0-48a8,8,0,0,1-16,0V72a8,8,0,0,1,16,0Zm64,96a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm64,0a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm0-48a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Z"/>
        </svg>`;
    case 'spare_room':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 256 256">
          <path fill="currentColor" d="M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-40,0H176V40h16ZM64,40h96V216H64Zm80,92a12,12,0,1,1-12-12A12,12,0,0,1,144,132Z"></path>
        </svg>`;
    case 'House':
    default:
      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 256 256">
        <rect width="256" height="256" fill="none"/>
        <path fill="currentColor" d="M224,120v96a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V164a4,4,0,0,0-4-4H108a4,4,0,0,0-4,4v52a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120a16,16,0,0,1,4.69-11.31l80-80a16,16,0,0,1,22.62,0l80,80A16,16,0,0,1,224,120Z"/>
        </svg>`;
  }
}
